const SET_GROUPS = 'SET_GROUPS';

const SET_USERS_PAYER = 'SET_USERS_PAYER';

const SET_USERS_PARTICIPANT = 'SET_USERS_PARTICIPANT';

const SET_START_DATE = 'SET_START_DATE';

const SET_SELECT_PAYMENT_FORM = 'SET_SELECT_PAYMENT_FORM';

const SET_PROMO_DATA = 'SET_PROMO_DATA';

const SET_PROMOTIONS_SALES_ID_ARRAY = 'SET_PROMOTIONS_SALES_ID_ARRAY';

const SET_ALL_INSTALLMENTS = 'SET_ALL_INSTALLMENTS';

const SET_SELECT_PAYMENTS_RAIRS = 'SET_SELECT_PAYMENTS_RAIRS';

const SET_SELECT_COURSES_HEADINGS = 'SET_SELECT_COURSES_HEADINGS';

const SET_PAYMENR_ZERO = 'SET_PAYMENR_ZERO';

const SET_FULL_INSTALMENT = 'SET_FULL_INSTALMENT';

const SET_SELECT_COURSES_HEADINGS_NAME = 'SET_SELECT_COURSES_HEADINGS_NAME';

const SET_ENTRY_FEE = 'SET_ENTRY_FEE';

const SET_SELECT_CHECKBOX_CONTRACT = 'SET_SELECT_CHECKBOX_CONTRACT';

const SET_NIP = 'SET_NIP';

const SET_ALL_INSTALLMENTS_PRICE = 'SET_ALL_INSTALLMENTS_PRICE';

const SET_CARD_ID = 'SET_CARD_ID';

const SET_MESSEGE_COMPLIT = 'SET_MESSEGE_COMPLIT'

const defoultState = {
    item: [],
    isFetching: true,
    groups: 0,
};

export default function reposReducer(state = defoultState, action) {
    switch (action.type) {
        case SET_GROUPS:
            return {
                ...state,
                groups: action.peyload,
            };

        case SET_USERS_PAYER:
            return {
                ...state,
                users: action.peyload,
            };

        case SET_USERS_PARTICIPANT:
            return {
                ...state,
                usersParticipant: action.peyload,
            };

        case SET_START_DATE:
            return {
                ...state,
                date: action.peyload,
            };

        case SET_SELECT_PAYMENT_FORM:
            return {
                ...state,
                payForm: action.peyload,
            };

        case SET_PROMO_DATA:
            return {
                ...state,
                promotionsData: action.peyload,
            };

        case SET_PROMOTIONS_SALES_ID_ARRAY:
            return {
                ...state,
                promotionsSalesIDArray: action.peyload,
            };

        case SET_ALL_INSTALLMENTS:
            return {
                ...state,
                allInstallments: action.peyload,
            };

        case SET_SELECT_PAYMENTS_RAIRS:
            return {
                ...state,
                selectedInstallments: action.peyload,
            };

        case SET_SELECT_COURSES_HEADINGS:
            return {
                ...state,
                coursesHeadings: action.peyload,
            };

        case SET_PAYMENR_ZERO:
            return {
                ...state,
                payzero: action.peyload,
            };

        case SET_FULL_INSTALMENT:
            return {
                ...state,
                index: action.peyload,
            };

        case SET_SELECT_COURSES_HEADINGS_NAME:
            return {
                ...state,
                chName: action.peyload,
            };

        case SET_ENTRY_FEE:
            return {
                ...state,
                entryFee: action.peyload,
            };

        case SET_SELECT_CHECKBOX_CONTRACT:
            return {
                ...state,
                contractCheckbox: action.peyload,
            };

        case SET_NIP:
            return {
                ...state,
                nip: action.peyload,
            };

        case SET_ALL_INSTALLMENTS_PRICE:
            return {
                ...state,
                allInstallmentsPrice: action.peyload,
            };
        case SET_CARD_ID:
            return {
                ...state,
                cardID: action.peyload,
            };
        case SET_MESSEGE_COMPLIT:
            return {
                ...state,
                messege: action.peyload,
            };
        default:
            return state;
    }
}

export const setcontractCheckbox = (contractCheckbox) => ({
    type: SET_SELECT_CHECKBOX_CONTRACT,
    peyload: contractCheckbox,
});


export const setGroups = (groups) => ({ type: SET_GROUPS, peyload: groups });

export const setUsersPayer = (users) => ({ type: SET_USERS_PAYER, peyload: users });

export const setUsersParticipant = (usersParticipant) => ({
    type: SET_USERS_PARTICIPANT,
    peyload: usersParticipant,
});

export const setStartDate = (date) => ({ type: SET_START_DATE, peyload: date });

export const setPaymentData = (payForm) => ({ type: SET_SELECT_PAYMENT_FORM, peyload: payForm });

export const setPromotionsData = (promotionsData) => ({
    type: SET_PROMO_DATA,
    peyload: promotionsData,
});

export const setPromotionsSalesIDArray = (promotionsSalesIDArray) => ({
    type: SET_PROMOTIONS_SALES_ID_ARRAY,
    peyload: promotionsSalesIDArray,
});

export const setAllInstallments = (allInstallments) => ({
    type: SET_ALL_INSTALLMENTS,
    peyload: allInstallments,
});

export const setSelectedInstallments = (selectedInstallments) => ({
    type: SET_SELECT_PAYMENTS_RAIRS,
    peyload: selectedInstallments,
});

export const setCurseHadings = (coursesHeadings) => ({
    type: SET_SELECT_COURSES_HEADINGS,
    peyload: coursesHeadings,
});

export const setPayzero = (payzero) => ({
    type: SET_PAYMENR_ZERO,
    peyload: payzero,
});

export const setObligatoryInstallmentNumber = (index) => ({
    type: SET_FULL_INSTALMENT,
    peyload: index,
});

export const setChName = (chName) => ({
    type: SET_SELECT_COURSES_HEADINGS_NAME,
    peyload: chName,
});

export const setEntryFee = (entryFee) => ({
    type: SET_ENTRY_FEE,
    peyload: entryFee,
});

export const setNip = (nip) => ({
    type: SET_NIP,
    peyload: nip,
});

export const setAllInstallmentsPriceReducer = (allInstallmentsPrice) => ({
    type: SET_ALL_INSTALLMENTS_PRICE,
    peyload: allInstallmentsPrice,
});

export const setCardID = (cardID) => ({
    type: SET_CARD_ID,
    peyload: cardID,
});

export const setMessege = (message) => ({
    type: SET_MESSEGE_COMPLIT,
    peyload: message,
});